import { gigQueryOptions } from "api/queries/stafferGigs";
import type { MarketplaceSearch } from "domains/schedule/utils/useMarketplaceSearch";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { search: MarketplaceSearch };

export const copySourceGigQuery = ({ search }: QueriesInput) => ({
  ...gigQueryOptions(search.copy_from_gig_id),
  enabled: search.copy_from_gig_id != null,
});

export const queries = (input: QueriesInput): Array<WarmableQuery> => [copySourceGigQuery(input)];
